import React from 'react';
import { Link } from 'react-router-dom';

// Used for homepage buttons that link to individual pages.
const MenuButton = (props) => {
    const handleKeyPress = (event) => {
        if (event.key === 'Enter'){
        props.setPage(props.link)
        }
    }

    return (
        <Link
            className="menu-button" 
            to={`/${props.link}`}
            onClick={()=>props.setPage(props.link)}
            onKeyPress={handleKeyPress}
            role='button'
            tabIndex='0'
            aria-label={props.label}
        >
            {props.label}
            <i className="fa fa-chevron-right"></i>
        </Link>
    );
}

export default MenuButton;